import { render, staticRenderFns } from "./user-conversations.component.vue?vue&type=template&id=65796f04"
import script from "./user-conversations.component.ts?vue&type=script&lang=ts&external"
export * from "./user-conversations.component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-conversations.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports